import React, { useState } from "react";
import { Modal, Form, Row, Col, Button } from 'antd';
import { config } from "util/config";
import { httpClient } from 'util/Api';
import { useHistory } from "react-router-dom";
import * as globalFunction from 'util/GlobalFunction';
import Invoice from "./Invoice";
import Quote from "./Quote";

const MPGS = () => {
  // 公共付款入口统一使用明确的浏览器页签标题。
  document.title = 'Online Payment';

  const history = useHistory();
  let pathname = window.location.pathname.split('/');

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <MPGSPage type={pathname[pathname.length - 2]} history={history} />
  )
}
export default MPGS;

class MPGSPage extends React.Component {
  constructor(props) {
    super();
    this.state = {

    }
  }

  showPayPage() {
    switch (this.props.type.toLowerCase()) {
      case 'invoice':
        return <Invoice />;
      case 'quote':
        return <Quote />;
    }
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        {this.showPayPage()}
      </div>
    );
  }
};
